/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type RolesAndPermissionsEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const rolesAndPermissionsEntryPoint: EntryPoint<RolesAndPermissionsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<RolesAndPermissionsEntryPointComponent>(
			/* webpackChunkName: "async-insight-global-configuration-roles-and-permissions-main" */ './RolesAndPermissionsPage.tsx',
		),
		getPreloadProps: () => ({}),
	});
